 // Select all elements with the .side class
        const sideElements = document.querySelectorAll('.side');
        let currentIndex = 0;

        // Function to animate the next element
        function animateNextTag() {
            // Add the 'animate' class to the current element
            sideElements[currentIndex].classList.add('animate');

            // Remove the 'animate' class after the animation completes
            setTimeout(() => {
                sideElements[currentIndex].classList.remove('animate');
                currentIndex++;

                // Reset the index if it exceeds the number of elements
                if (currentIndex >= sideElements.length) {
                    currentIndex = 0;
                }

                // Call the function again to animate the next element
                animateNextTag();
            }, 1300); // Adjust the delay to match the animation duration
        }

        // Start the animation
        animateNextTag();
